import React from 'react';
import Select from '../index';

const SelectFilter = ({
  selectedOption,
  options,
  onChange,
  dropdownIcon = null,
  isDisabled = false,
  isClearable = true,
  ...otherProps
}) => {
  // Extract components from otherProps if present
  const { components, ...restProps } = otherProps;

  // Merge custom components with default dropdown logic
  const mergedComponents = {
    ...(components || {}),
    ...(dropdownIcon === false && {
      DropdownIndicator: null
    })
  };

  // Only include components if we have any to pass
  const hasComponents = components || dropdownIcon === false;
  return (
    <Select
      value={selectedOption}
      customStyles={{
        container: {
          height: 25,
          minHeight: 25
        },
        control: {
          border: 0,
          borderBottom: '1px solid rgba(134,142,150,0.3)',
          backgroundColor: isDisabled ? '#e8eaeb !important' : 'transparent',
          height: '25px',
          minHeight: '25px'
        },
        valueContainer: {
          height: 25,
          paddingLeft: 0,
          marginLeft: 0
        },
        placeholder: {
          fontStyle: 'normal'
        }
      }}
      dropdownProps={{
        backgroundColor: 'rgba(226,93,52,0.2)'
      }}
      clearProps={
        selectedOption && {
          styles: `
              width:15px;
              height:15px;
              border-radius:50%;
              background-color:rgba(31,43,55,0.1);
              display:flex;
              align-items:center;
              justify-content:center;
              span{
                width:15px !important;
                 height:15px !important;
              }
            `,
          colorIcon: 'rgba(39,53,68,0.5)'
        }
      }
      {...(hasComponents && { components: mergedComponents })}
      onChange={onChange}
      options={options}
      dropdownIcon={dropdownIcon}
      isClearable={isClearable}
      {...restProps}
    />
  );
};

export default SelectFilter;
